import { GenerateQrContainer } from '@/modules/QrCode';

const GenerateQr = (): JSX.Element => <GenerateQrContainer />;

export default GenerateQr;
